import type { SubscriptionDetails } from "schemas/generated/billing";

import * as React from "react";

import { skipToken } from "@tanstack/react-query";
import { billingRouter } from "@v2/trpc/routes/billing";

const NextBillingDate = ({
  workspaceId,
  activeSubscription,
  isChosenPlanOnYearlyInterval,
  className,
}: {
  workspaceId: string;
  activeSubscription?: SubscriptionDetails;
  isChosenPlanOnYearlyInterval: boolean;
  className?: string;
}) => {
  const { data: nextBillingDate } =
    billingRouter.getNextCorePlanBillingDate.useQuery(
      workspaceId && activeSubscription?.id
        ? {
            workspaceId,
            subscriptionId: activeSubscription.id,
          }
        : skipToken,
    );

  const formattedNextBillingDate = React.useMemo(() => {
    if (nextBillingDate) {
      return new Date(nextBillingDate).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } else {
      const futureDate = new Date();
      if (isChosenPlanOnYearlyInterval) {
        futureDate.setFullYear(futureDate.getFullYear() + 1);
      } else {
        futureDate.setMonth(futureDate.getMonth() + 1);
      }
      return futureDate.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    }
  }, [nextBillingDate, isChosenPlanOnYearlyInterval]);

  return <span className={className}>{formattedNextBillingDate}</span>;
};

export default NextBillingDate;
